import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Found an amazing plumber within hours. The quotes were competitive and the whole process was seamless.',
    author: 'Sarah M.',
    location: 'Austin, TX',
    service: 'Plumbing'
  }, {
    quote: 'I was dreading finding a roofer after the storm. This site made it incredibly easy to compare options and prices.',
    author: 'James K.',
    location: 'Denver, CO',
    service: 'Roofing'
  }, {
    quote: 'Used it twice now for electrical work. Both times I got great pros at fair prices. Highly recommend.',
    author: 'Maria L.',
    location: 'Portland, OR',
    service: 'Electrical'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="reviews" className="py-20 bg-white" data-id="element-595">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-596">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-597">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-598">
            What Homeowners Say
          </h2>
          <p className="text-lg text-slate-600" data-id="element-599">
            Real reviews from real customers
          </p>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-600">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm flex flex-col h-full" data-id="element-601">
              <div className="flex gap-1 mb-6" data-id="element-602">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-603" />)}
              </div>

              <blockquote className="text-slate-700 text-lg leading-relaxed mb-8 flex-1" data-id="element-604">
                "{testimonial.quote}"
              </blockquote>

              <div className="flex items-center justify-between pt-6 border-t border-slate-100 mt-auto" data-id="element-605">
                <div data-id="element-606">
                  <div className="font-bold text-slate-900" data-id="element-607">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-slate-500" data-id="element-608">
                    {testimonial.location}
                  </div>
                </div>
                <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-700" data-id="element-609">
                  {testimonial.service}
                </span>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}